module.exports = __webpack_public_path__ + "assets/img/news3.3.be682745.png";